import axios from "@/plugins/axios";

let url = "/api/device-info";

export default {
    get(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};
